import tw from "twin.macro";
import { Link } from "react-router-dom";

export const PrimaryLink = tw(Link)`cursor-pointer font-bold text-primary-500 border-b-2 border-transparent hocus:border-primary-500 hocus:text-primary-800 transition duration-300`;
